<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-row class="mx-0">
        <v-col cols="6" class="px-1">
          <v-btn
            color="primary"
            class="mr-0"
            outlined
            :loading="isLoading"
            @click="addItems"
          >
            {{ $t("addSite") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-expansion-panels v-model="panel" class="mt-8">
        <v-expansion-panel v-for="(item, i) in items" :key="i">
          <v-expansion-panel-header style="font-size: 14px">
            <div>
              <div>{{ $t("site") }} {{ i + 1 }}</div>
              <div class="abr-subtitle mt-2">
                {{ $t("domainName") }} , {{ $t("apiSecret") }} ,
                {{ $t("currencyRate") }} , {{ $t("registerStatus") }} , ...
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row class="mb-3">
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.woocommercePanelName"
                    :label="$t('woocommercePanelName')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    placeholder="abriron"
                    clearable
                    dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.woocommerceDomain"
                    :label="$t('domainName')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    placeholder="https://abriron.com/"
                    clearable
                    dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.woocommerceUsername"
                    :label="$t('apiKey')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    clearable
                    dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.woocommercePassword"
                    :label="$t('apiSecret')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    clearable
                    dense
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="item.woocommerceCurrencyRate"
                    :label="$t('currencyRate')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    clearable
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-chip
                    v-clipboard:copy="item.orderCallBack"
                    label
                    dark
                    color="green"
                    link
                    @click="copied"
                  >
                    {{ $t("orderWebhook") }} : {{ item.orderCallBack }}
                    <v-icon class="mx-2"> mdi-content-copy </v-icon>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-chip
                    v-clipboard:copy="item.productCallBack"
                    label
                    dark
                    color="green"
                    link
                    @click="copied"
                  >
                    {{ $t("orderProduct") }} : {{ item.productCallBack }}
                    <v-icon class="mx-2"> mdi-content-copy </v-icon>
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-chip
                    v-clipboard:copy="item.abrKey"
                    label
                    dark
                    color="green"
                    link
                    @click="copied"
                  >
                    {{ $t("abrID") }} : {{ item.abrKey }}
                    <v-icon class="mx-2"> mdi-content-copy </v-icon>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.woocommerceRegisterStatus"
                    :label="$t('registerStatus')"
                    :items="statusItems"
                    height="30"
                    dense
                    outlined
                    clearable
                    item-value="value"
                    item-text="text"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.woocommerceEditStatus"
                    :label="$t('editStatus')"
                    :items="statusItems"
                    height="30"
                    dense
                    outlined
                    clearable
                    item-value="value"
                    item-text="text"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.woocommerceRemoveStatus"
                    :label="$t('removeStatus')"
                    :items="statusItems"
                    height="30"
                    dense
                    outlined
                    clearable
                    item-value="value"
                    item-text="text"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.woocommerceReturnSellStatus"
                    :label="$t('returnSellStatus')"
                    :items="statusItems"
                    height="30"
                    dense
                    outlined
                    clearable
                    item-value="value"
                    item-text="text"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <autocomplete
                    v-model="item.entrepot"
                    :title="$t('entrepotToUse')"
                    type="entrepot"
                    :outlined="true"
                    :value="item.entrepot"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <autocomplete
                    v-model="item.woocommerceBranch"
                    :title="$t('defaultBranch')"
                    type="branch"
                    :outlined="true"
                    :value="item.woocommerceBranch"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="item.woocommerceExpireDateKey"
                    :label="$t('woocommerceExpireDateKey')"
                    outlined
                    clearable
                    dense
                  />
                </v-col>
                <v-col md="3">
                  <v-checkbox
                    v-model="item.woocommerceUpdateStock"
                    class="mt-0"
                    :label="$t('updateStock')"
                    value="yes"
                  />
                </v-col>
                <v-col md="3">
                  <v-checkbox
                    v-model="item.woocommerceUpdatePrice"
                    class="mt-0"
                    :label="$t('updatePrice')"
                    value="yes"
                  />
                </v-col>
                <v-col md="4">
                  <v-checkbox
                    v-model="item.woocommerceUseAllEntrepot"
                    class="mt-0 woocommerce-checkbox-rtl"
                    :label="$t('woocommerceUseAllEntrepot')"
                    value="yes"
                    hide-details
                  />
                </v-col>
                <v-col md="4">
                  <v-checkbox
                    v-model="item.woocommerceProductDraft"
                    class="mt-0 woocommerce-checkbox-rtl"
                    :label="$t('woocommerceRegisterProductAsDraft')"
                    value="yes"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-3">
                  <v-btn color="green" class="mr-0" small @click="addPaymentMethod(item)">
                    {{ $t("addPeymentMethod") }}
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  v-for="(itemPayment, index) in item.woocommercePaymentItems"
                  :key="index"
                  cols="12"
                  class="d-flex pa-0"
                >
                  <v-col cols="5">
                    <autocomplete
                      v-model="itemPayment.bank"
                      :title="$t('bank') + '/' + $t('cash')"
                      type="allBankCash"
                      :rules="[(v) => !!v || $t('is-required')]"
                      :outlined="true"
                      :value="itemPayment.bank"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="itemPayment.value"
                      :label="$t('method')"
                      :rules="[(v) => !!v || $t('is-required')]"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-btn x-small class="mt-1" icon @click="remove(i, index)">
                      <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn color="primary" class="mr-0" :loading="isLoading" @click="create">
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn color="grey" outlined class="float-left" @click="$emit('close')">
              {{ $t("cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import autocomplete from "../../components/general/patial/autocomplete";
import General from "../../../../Mixins/general";
export default {
  name: "Customer",
  components: {
    // aicomplete,
    autocomplete,
  },
  mixins: [General],
  data: () => ({
    valid: true,
    updatePrice: null,
    items: [],
    updateStock: null,
    woocommerceReturnSellStatus: null,
    panel: 0,
    editStatus: null,
    removeStatus: null,
    registerStatus: null,
    branch: null,
    woocommerceUpdatePrice: null,
    woocommerceUpdateStock: null,
    woocommerceUseAllEntrepot: null,
    woocommerceProductDraft: null,
    entrepot: null,
    entrepotEdit: null,
    username: null,
    paymentItems: [],
    password: null,
    domain: null,
    hashkey: null,
    countWoocommercepanel: 1,
    rate: null,
    type: null,
    render: false,
    isLoading: false,
  }),
  watch: {},
  activated() {
    this.show();
  },
  beforeMount() {
    this.statusItems = [
      {
        value: "pending",
        text: this.$t("pending"),
      },
      {
        value: "processing",
        text: this.$t("processing"),
      },
      {
        value: "on-hold",
        text: this.$t("on-hold"),
      },
      {
        value: "completed",
        text: this.$t("completed"),
      },
      {
        value: "cancelled",
        text: this.$t("cancelled"),
      },
      {
        value: "refunded",
        text: this.$t("refunded"),
      },
      {
        value: "failed",
        text: this.$t("failed"),
      },
      {
        value: "pws-in-stock",
        text: this.$t("pws-in-stock"),
      },
    ];
  },
  mounted() {
    this.show();
    if (
      this.$store.state.allConfig &&
      this.$store.state.allConfig.countWoocommercePanel
    ) {
      this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel;
    }
    if (this.items.length === 0) {
      this.addItems();
    }
  },
  methods: {
    addItems() {
      if (this.items.length < this.countWoocommercepanel) {
        var item = {
          woocommercePanelName: null,
          woocommerceDomain: null,
          woocommerceUsername: null,
          woocommercePassword: null,
          woocommerceCurrencyRate: null,
          hashkey: null,
          woocommerceRegisterStatus: null,
          woocommerceEditStatus: null,
          woocommerceRemoveStatus: null,
          woocommerceReturnSellStatus: null,
          entrepot: null,
          woocommerceBranch: null,
          woocommerceUpdateStock: null,
          woocommerceUpdatePrice: null,
          woocommerceUseAllEntrepot: null,
          woocommerceProductDraft: null,
          woocommerceExpireDateKey: null,
          woocommercePaymentItems: [],
        };
        this.items.push(item);
      }
    },
    addPaymentMethod(item) {
      if (!item.woocommercePaymentItems) {
        this.$set(item, "woocommercePaymentItems", []);
      }
      item.woocommercePaymentItems.push({
        bank: null,
        value: null,
      });
    },
    remove(panel, index) {
      this.items[panel].woocommercePaymentItems.splice(index, 1);
    },
    create() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "woocommerce", this.$data)
        .then((res) => {
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "woocommerce", {
          params: {},
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.items = res;
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    copied() {
      this.snakbarText = this.$t("copied");
      this.snakbarColor = "blue";
      this.snakbar = true;
    },
  },
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
.col:has(.woocommerce-checkbox-rtl) {
  height: auto !important;
}
::v-deep .woocommerce-checkbox-rtl .v-label {
  text-align: right;
  direction: rtl;
  white-space: normal;
  line-height: 1.4;
}
::v-deep .woocommerce-checkbox-rtl .v-input__slot {
  align-items: flex-start;
}
</style>
